import React, { useState } from 'react';

import { Caret } from 'components/Modals/Icons';
import * as Modal from 'components/Modals/styles';
import { Options, OptionBtn, SlippageDesc } from './exchangemodalStyles';

const limitOptions = [
  {
    label: 'No limit',
    value: 10000,
  },
  {
    label: '1%',
    value: 100,
  },
  {
    label: '2.5%',
    value: 250,
  },
  {
    label: '5%',
    value: 500,
  },
];

export function SlippageDetails({
  slippage,
  setSlippage,
}: {
  slippage: number;
  setSlippage: (s: number) => void;
}) {
  const [showSlippageDetails, setShowSlippageDetails] = useState(false);
  const selectedSlippage = limitOptions.find(o => o.value === slippage);
  const selectedSlippageDisplay =
    selectedSlippage?.value === 10000 || !selectedSlippage ? null : selectedSlippage.label;

  return (
    <>
      <Modal.DetailsButton
        active={showSlippageDetails}
        onClick={() => setShowSlippageDetails(!showSlippageDetails)}
        data-testid="confirm-modal-slippage-button"
      >
        Slippage Limit {selectedSlippageDisplay && <>({selectedSlippageDisplay})</>} <Caret />
      </Modal.DetailsButton>

      {showSlippageDetails && (
        <>
          <Options>
            {limitOptions.map(slippageOption => (
              <OptionBtn
                active={slippage === slippageOption.value}
                key={slippageOption.value}
                onClick={() => setSlippage(slippageOption.value)}
              >
                {slippageOption.label}
              </OptionBtn>
            ))}
          </Options>
          <SlippageDesc>
            Slippage is likely in times of high demand. Quote is based on most recent block and does
            not reflect transactions ahead of you in the mempool
          </SlippageDesc>
        </>
      )}
    </>
  );
}
